/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Email_Changed_Success_AlertInputs */

const en_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Brave account email has been changed successfully. Please sign in again using your new email address.`)
};

const id_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email akun Brave Anda telah berhasil diubah. Silakan masuk kembali menggunakan alamat email baru Anda.`)
};

const ms_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emel akaun Brave anda telah berjaya ditukar. Sila log masuk semula menggunakan alamat emel baharu anda.`)
};

const ca_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'adreça de correu electrònic del teu compte Brave s'ha canviat amb èxit. Si us plau, inicia sessió de nou utilitzant la teva nova adreça de correu electrònic.`)
};

const cs_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaše emailová adresa byla úspěšně změněna. Přihlaste se znovu pomocí nové emailové adresy.`)
};

const da_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Din Brave-konto e-mail er blevet ændret. Log venligst ind igen med din nye e-mailadresse.`)
};

const de_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre Brave-Konto-E-Mail-Adresse wurde erfolgreich geändert. Bitte melden Sie sich erneut mit Ihrer neuen E-Mail-Adresse an.`)
};

const et_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teie Brave konto e-posti aadress on edukalt muudetud. Logige uuesti sisse, kasutades oma uut e-posti aadressi.`)
};

const es_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El correo electrónico de tu cuenta de Brave se ha cambiado exitosamente. Por favor, inicia sesión nuevamente usando tu nueva dirección de correo electrónico.`)
};

const fr_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’adresse e-mail de votre compte Brave a été modifiée. Veuillez vous reconnecter avec votre nouvelle adresse e-mail.`)
};

const hr_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaša Brave račun e-mail adresa je uspješno promijenjena. Molimo prijavite se ponovo koristeći svoju novu e-mail adresu.`)
};

const it_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'email del tuo account Brave è stata cambiata con successo. Accedi nuovamente utilizzando il tuo nuovo indirizzo email.`)
};

const lv_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūsu Brave konta e-pasta adrese veiksmīgi mainīta. Lūdzu, piesakieties vēlreiz, izmantojot jauno e-pasta adresi.`)
};

const lt_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūsų Brave paskyros el. pašto adresas buvo sėkmingai pakeistas. Prisijunkite dar kartą naudodami naują el. pašto adresą.`)
};

const hu_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az email címét sikeresen megváltoztatta. Kérjük, jelentkezzen be újra az új e-mail cím használatával.`)
};

const nl_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je Brave-account e-mailadres is succesvol gewijzigd. Meld je opnieuw aan met je nieuwe e-mailadres.`)
};

const nb_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-postadressen koblet til Brave-kontoen din er endret. Logg inn på nytt med den nye e-postadressen din.`)
};

const pl_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adres e-mail dla Twojego konta Brave został pomyślnie zmieniony. Zaloguj się ponownie, używając nowego adresu e-mail.`)
};

const pt_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O e-mail da sua conta Brave foi alterado com sucesso. Faça login novamente usando seu novo endereço de e-mail.`)
};

const ro_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresa de e-mail a contului dvs. Brave a fost schimbată cu succes. Vă rugăm să vă conectați din nou folosind noua adresă de e-mail.`)
};

const sk_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail vášho účtu Brave bol úspešne zmenený. Prihláste sa znova pomocou vašej novej e-mailovej adresy.`)
};

const sl_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaš e-poštni naslov Brave je bil uspešno spremenjen. Prosimo, ponovno se prijavite z vašim novim e-poštnim naslovom.`)
};

const fi_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave-tilisi sähköpostiosoite on muutettu onnistuneesti. Kirjaudu sisään uudelleen käyttämällä uutta sähköpostiosoitettasi.`)
};

const sv_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Din Brave-kontoadress har ändrats framgångsrikt. Vänligen logga in igen med din nya e-postadress.`)
};

const vi_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email tài khoản Brave của bạn đã được thay đổi thành công. Vui lòng đăng nhập lại bằng địa chỉ email mới của bạn.`)
};

const tr_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave hesabınızın e-posta adresi başarıyla değiştirildi. Lütfen yeni e-posta adresinizle yeniden oturum açın.`)
};

const el_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η διεύθυνση email του λογαριασμού σας στο Brave άλλαξε επιτυχώς. Παρακαλούμε συνδεθείτε ξανά χρησιμοποιώντας τη νέα διεύθυνση email σας.`)
};

const bg_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имейлът на вашия Brave акаунт беше успешно променен. Моля, влезте отново, използвайки новия си имейл адрес.`)
};

const ru_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Адрес электронной почты вашего аккаунта Brave успешно изменен. Пожалуйста, выполните вход заново, используя новый адрес электронной почты.`)
};

const sr_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имејл вашег Brave налога је успешно промењен. Молимо вас да се поново пријавите користећи нову имејл адресу.`)
};

const uk_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Адресу електронної пошти вашого облікового запису Brave успішно змінено. Будь ласка, увійдіть знову за допомогою вашої нової адреси електронної пошти.`)
};

const ka_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`თქვენი Brave ანგარიშის მეილი წარმატებით შეიცვალა. გთხოვთ, კვლავ შეხვალთ ახალ მეილის მისამართით.`)
};

const hi_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपके Brave खाते का ईमेल सफलतापूर्वक बदल दिया गया है। कृपया अपने नए ईमेल पते का उपयोग करके फिर से साइन इन करें।`)
};

const th_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ที่อยู่อีเมลในบัญชี Brave ของคุณได้ถูกเปลี่ยนแปลงแล้ว โปรดลงชื่อเข้าใช้อีกครั้งโดยใช้ที่อยู่อีเมลใหม่ของคุณ`)
};

const ko_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave 계정 이메일을 변경했습니다. 새 이메일 주소로 다시 로그인하세요.`)
};

const zh_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的 Brave 账户电子邮件地址已成功更改。请使用新的电子邮件地址重新登录。`)
};

const zh_tw_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的 Brave 帳戶電子郵件已成功變更。請使用新的電子郵件地址重新登入。`)
};

const ja_email_changed_success_alert = /** @type {(inputs: Email_Changed_Success_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Braveアカウントのメールアドレスが正常に変更されました。新しいメールアドレスで再度サインインしてください。`)
};

/**
* | output |
* | --- |
* | "Your Brave account email has been changed successfully. Please sign in again using your new email address." |
*
* @param {Email_Changed_Success_AlertInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const email_changed_success_alert = /** @type {((inputs?: Email_Changed_Success_AlertInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Changed_Success_AlertInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_email_changed_success_alert(inputs)
	if (locale === "ms") return ms_email_changed_success_alert(inputs)
	if (locale === "ca") return ca_email_changed_success_alert(inputs)
	if (locale === "cs") return cs_email_changed_success_alert(inputs)
	if (locale === "da") return da_email_changed_success_alert(inputs)
	if (locale === "de") return de_email_changed_success_alert(inputs)
	if (locale === "et") return et_email_changed_success_alert(inputs)
	if (locale === "es") return es_email_changed_success_alert(inputs)
	if (locale === "fr") return fr_email_changed_success_alert(inputs)
	if (locale === "hr") return hr_email_changed_success_alert(inputs)
	if (locale === "it") return it_email_changed_success_alert(inputs)
	if (locale === "lv") return lv_email_changed_success_alert(inputs)
	if (locale === "lt") return lt_email_changed_success_alert(inputs)
	if (locale === "hu") return hu_email_changed_success_alert(inputs)
	if (locale === "nl") return nl_email_changed_success_alert(inputs)
	if (locale === "nb") return nb_email_changed_success_alert(inputs)
	if (locale === "pl") return pl_email_changed_success_alert(inputs)
	if (locale === "pt") return pt_email_changed_success_alert(inputs)
	if (locale === "ro") return ro_email_changed_success_alert(inputs)
	if (locale === "sk") return sk_email_changed_success_alert(inputs)
	if (locale === "sl") return sl_email_changed_success_alert(inputs)
	if (locale === "fi") return fi_email_changed_success_alert(inputs)
	if (locale === "sv") return sv_email_changed_success_alert(inputs)
	if (locale === "vi") return vi_email_changed_success_alert(inputs)
	if (locale === "tr") return tr_email_changed_success_alert(inputs)
	if (locale === "el") return el_email_changed_success_alert(inputs)
	if (locale === "bg") return bg_email_changed_success_alert(inputs)
	if (locale === "ru") return ru_email_changed_success_alert(inputs)
	if (locale === "sr") return sr_email_changed_success_alert(inputs)
	if (locale === "uk") return uk_email_changed_success_alert(inputs)
	if (locale === "ka") return ka_email_changed_success_alert(inputs)
	if (locale === "hi") return hi_email_changed_success_alert(inputs)
	if (locale === "th") return th_email_changed_success_alert(inputs)
	if (locale === "ko") return ko_email_changed_success_alert(inputs)
	if (locale === "zh") return zh_email_changed_success_alert(inputs)
	if (locale === "zh-tw") return zh_tw_email_changed_success_alert(inputs)
	if (locale === "ja") return ja_email_changed_success_alert(inputs)
	return en_email_changed_success_alert(inputs)
});